module.exports = __webpack_public_path__ + "static/img/smile.6a667c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/smile.png
// module id = 0Pzk
// module chunks = 1